import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { parseTicketsSearch, type TicketsSearch } from "@/components/tickets/list/search";
import { TicketsPage } from "@/components/tickets/list/tickets-page";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/tickets/")({
  // The filters live in the URL and nowhere else, so a reload, the back
  // button and a link someone was sent all give the same list. Whatever the
  // URL says, this returns filters the page can use: it never throws.
  validateSearch: (search: Record<string, unknown>): TicketsSearch => parseTicketsSearch(search),
  component: TicketsRoute,
});

function TicketsRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: TicketsSearch, options?: { replace?: boolean }) =>
      void navigate({ search: next, replace: options?.replace }),
    [navigate],
  );
  // Keyed by project: the selection and the folded groups are one project's.
  return <TicketsPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
